import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';

@Component({
  selector: 'internal-info',
  templateUrl: './internal-info.component.html',
  styleUrls: ['./internal-info.component.scss']
})
export class InternalInfoComponent implements OnInit {
  @Input()
  subProject: SubProject;

  @Output()
  public save = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
